export class EmailModel {

    constructor() {
        this.RecipientsTo = [];
    }

    public RecipientsTo: Array<string>;

    public Title: string;

    public Content: string;

    public Attachments: Array<string>;
}